/**
 * Einstiegspunkt der internen Arbeitsumgebung.
 *
 * Die Schriften werden hier geladen, damit sie im Bundle landen statt bei
 * Google (docs/technik/branding.md Abschnitt 2).
 *
 * Nur die Schnitte, die verwendet werden, und nur die Zeichensaetze, die
 * gebraucht werden: `latin` traegt Deutsch und Englisch, `latin-ext` die
 * Kundennamen mit polnischen, tschechischen oder tuerkischen Zeichen. Ohne die
 * Einschraenkung liefert @fontsource auch Kyrillisch, Griechisch, Devanagari
 * und Mathematik-Symbole mit — 16 zusaetzliche Dateien fuer nichts.
 */
import '@fontsource/poppins/latin-400.css'
import '@fontsource/poppins/latin-ext-400.css'
import '@fontsource/open-sans/latin-400.css'
import '@fontsource/open-sans/latin-ext-400.css'
import '@fontsource/open-sans/latin-600.css'
import '@fontsource/open-sans/latin-ext-600.css'

import { QueryClientProvider } from '@tanstack/react-query'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'

import { App } from './App'
import { erzeugeQueryClient } from './api/queries'
import './branding/index.css'
import './i18n'

const wurzel = document.getElementById('root')
if (!wurzel) {
  throw new Error('Kein #root im Dokument — index.html passt nicht zum Bundle.')
}

createRoot(wurzel).render(
  <StrictMode>
    <QueryClientProvider client={erzeugeQueryClient()}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </QueryClientProvider>
  </StrictMode>,
)
